import Marquee from "react-fast-marquee";
import { TOOLS } from "../data";

export default function ToolsMarquee() {
  return (
    <section data-testid="tools-marquee" className="relative py-10 md:py-14">
      <p className="text-center font-display text-ink-soft text-sm md:text-base mb-7">
        Tools I use on a daily basis
      </p>
      <Marquee speed={38} gradient gradientColor="#EDEBE5" gradientWidth={110} autoFill pauseOnHover>
        {TOOLS.map((t, i) => (
          <div
            key={i}
            data-testid={`tool-${t.name}`}
            className="mx-2.5 flex items-center gap-3 rounded-full bg-card border border-ink/10 px-5 py-3 shadow-[0_1px_2px_rgba(23,23,26,0.04)]"
          >
            <img src={t.logo} alt={`${t.name} logo`} className="w-6 h-6 object-contain" loading="lazy" />
            <span className="font-display font-medium text-lg text-ink/85 whitespace-nowrap">{t.name}</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
